import { ReportBlockTypeEnum } from '../enums/report-block-type.enum';
import { ChartSpecificTypesEnum } from '../enums/chart-specific-types.enum';

export enum ReportsDataMappingKeysEnum {
    DATE = 'date',
    SOURCE = 'source',
    AUTHOR = 'author',
    OUTLET = 'outlet',
    HASHTAG = 'hashtag',
    LOCATION = 'location',
    MEDIA_TYPE = 'mediaType',
    SENTIMENT = 'sentiment',
    METRIC = 'metric',
    GA_METRIC = 'gaMetric',
    REFERRER = 'referrer',
    REFERRER_TYPE = 'referralTypes',
    COVERAGE_IMPACT_TREND_METRIC = 'coverageImpactTrendMetric',
    DATE_INDEX = 'dateIndex',
    PERIOD = 'period'
};

export const reportsBlockMappingConfigurationMap = new Map<ReportBlockTypeEnum, any>([
    [
        ReportBlockTypeEnum.COVERAGE_OVER_TIME,
        {
            isMultiSources: false,
            isMultiDateRanges: false,
            isMultiMetrics: true,
            mappingKey: ReportsDataMappingKeysEnum.DATE,
            categoryKey: ReportsDataMappingKeysEnum.METRIC
        }
    ],
    [
        ReportBlockTypeEnum.SENTIMENT_TREND,
        {
            isMultiSources: false,
            isMultiDateRanges: false,
            isMultiMetrics: true,
            mappingKey: ReportsDataMappingKeysEnum.DATE,
            categoryKey: ReportsDataMappingKeysEnum.SENTIMENT
        }
    ],
    [
        ReportBlockTypeEnum.PROMINENCE_OVER_TIME,
        {
            isMultiSources: false,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            mappingKey: ReportsDataMappingKeysEnum.DATE,
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON,
        {
            isMultiSources: true,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            mappingKey: ReportsDataMappingKeysEnum.DATE,
            categoryKey: ReportsDataMappingKeysEnum.SOURCE
        }
    ],
    [
        ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME,
        {
            isMultiSources: false,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            mappingKey: ReportsDataMappingKeysEnum.AUTHOR,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.TOP_10_OUTLETS,
        {
            isMultiSources: false,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            mappingKey: ReportsDataMappingKeysEnum.OUTLET,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.TOP_HASHTAGS,
        {
            isMultiSources: false,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            mappingKey: ReportsDataMappingKeysEnum.HASHTAG,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON,
        {
            isMultiSources: true,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            filterEmptyDataValue: true,
            mappingKey: ReportsDataMappingKeysEnum.SOURCE,
            categoryKey: ReportsDataMappingKeysEnum.SENTIMENT,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR
                    || chartSpecificType === ChartSpecificTypesEnum.MULTI_STACKED_BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON,
        {
            isMultiSources: true,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            mappingKey: ReportsDataMappingKeysEnum.SOURCE,
            categoryKey: ReportsDataMappingKeysEnum.MEDIA_TYPE,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR
                    || chartSpecificType === ChartSpecificTypesEnum.MULTI_STACKED_BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.SENTIMENT_BREAKDOWN,
        {
            isMultiSources: false,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            mappingKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.SENTIMENT;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.SOURCE;
                }
            },
            categoryKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return null;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.SENTIMENT;
                }
            },
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN,
        {
            isMultiSources: false,
            isMultiDateRanges: false,
            isMultiMetrics: false,
            mappingKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.MEDIA_TYPE;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.SOURCE;
                }
            },
            categoryKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                        return null;
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.DATE;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.MEDIA_TYPE;
                }
            },
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.SHARE_OF_VOICE,
        {
            isMultiSources: true,
            isMultiDateRanges: true,
            isMultiMetrics: false,
            percentageAgainstSources: true,
            filterEmptyDataValue: true,
            mappingKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.SOURCE;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.DATE;
                }
            },
            categoryKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.DATE;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.SOURCE;
                }
            },
            percentageGroupKey: ReportsDataMappingKeysEnum.DATE,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK,
        {
            isMultiSources: false,
            isMultiDateRanges: true,
            isMultiMetrics: false,
            needsPercentage: true,

            mappingKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.MEDIA_TYPE;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.DATE;
                }
            },
            categoryKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.DATE;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.MEDIA_TYPE;
                }
            },
            percentageGroupKey: ReportsDataMappingKeysEnum.DATE,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_COMPARISON,
        {
            isMultiSources: true,
            isMultiDateRanges: true,
            isMultiMetrics: false,
            percentageAgainstSources: true,
            filterEmptyDataValue: true,
            mappingKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.SOURCE;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.DATE;
                }
            },
            categoryKey: (chartSpecificType: ChartSpecificTypesEnum) => {
                switch (chartSpecificType) {
                    case ChartSpecificTypesEnum.PIE:
                    case ChartSpecificTypesEnum.BAR:
                    case ChartSpecificTypesEnum.COLUMN:
                        return ReportsDataMappingKeysEnum.DATE;
                    case ChartSpecificTypesEnum.MULTI_STACKED_BAR:
                    case ChartSpecificTypesEnum.MULTI_STACKED_COLUMN:
                        return ReportsDataMappingKeysEnum.SOURCE;
                }
            },
            percentageGroupKey: ReportsDataMappingKeysEnum.DATE,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS,
        {
            mappingKey: ReportsDataMappingKeysEnum.REFERRER,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.TOP_REFERRAL_SOURCES,
        {
            mappingKey: ReportsDataMappingKeysEnum.SOURCE,
            categoryKey: ReportsDataMappingKeysEnum.GA_METRIC,
            percentageGroupKey: ReportsDataMappingKeysEnum.SOURCE,
            percentageAgainstSources: true,
            calculateStackedTotalPercent: true,
            sortByTotalDesc: true,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.REFERRAL_TREND,
        {
            mappingKey: ReportsDataMappingKeysEnum.DATE,
            categoryKey: ReportsDataMappingKeysEnum.REFERRER_TYPE
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_IMPACT_TREND,
        {
            mappingKey: ReportsDataMappingKeysEnum.DATE,
            categoryKey: ReportsDataMappingKeysEnum.COVERAGE_IMPACT_TREND_METRIC
        }
    ],
    [
        ReportBlockTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME,
        {
            mappingKey: ReportsDataMappingKeysEnum.LOCATION,
            reverseDataPointOrder: (chartSpecificType: ChartSpecificTypesEnum) => {
                return chartSpecificType === ChartSpecificTypesEnum.BAR;
            }
        }
    ],
    [
        ReportBlockTypeEnum.COVERAGE_METRIC,
        {
            mappingKey: ReportsDataMappingKeysEnum.DATE,
            groupKey: ReportsDataMappingKeysEnum.DATE_INDEX,
            categoryKey: ReportsDataMappingKeysEnum.PERIOD
        }
    ],
    // MAD chart configurations
    [
        ReportBlockTypeEnum.SENTIMENT_BY_MEDIA_TYPE,
        {
            mappingKey: ReportsDataMappingKeysEnum.MEDIA_TYPE,
            categoryKey: ReportsDataMappingKeysEnum.SENTIMENT
        }
    ]
]);
